import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardHeader, CardText, CardTitle,Modal,Placeholder } from 'react-bootstrap'
import { Dispositivo, Sensor } from '../Interfaces/Interfaces'
import { cambiarEstadoDispositivo, obtenerSensores } from '../Promesas/Promesas'
import { WiThermometer } from "react-icons/wi";
import { WiBarometer } from "react-icons/wi";
import { TbGps } from "react-icons/tb";
import { LuMove3D } from "react-icons/lu";
import { LuRotate3D} from "react-icons/lu";
import { GiCancel} from "react-icons/gi";
import { FaMountain } from "react-icons/fa";
import "../css/TarjetaDispositivos.css"
import { useNavigate } from 'react-router-dom';
interface Props{
    dispositivo:Dispositivo;
    isModify:boolean;
    setIsModify: React.Dispatch<React.SetStateAction<boolean>>;
    
}

const TarjetaDispositivos = (props:Props) => {
    //Modal begin
    const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //Modal end
    const navigate = useNavigate();
    const [isRender,setIsRender] = useState(false);
    const [sensores, setSensores] = useState<Sensor[]>([]);
    const [sensoresIcons,setSensoresIcons] = useState<any>([])
    useEffect(()=>{
        obtenerSensores(props.dispositivo).then((d)=>{
            setSensores(d);
            setIsRender(true);
            var icons = []
            if(d.find((s)=>s.tipo=="temperatura")!=undefined){
                icons.push(<WiThermometer/>);
                
            }
            if(d.find((s)=>s.tipo=="altitud")!=undefined){
                icons.push(<FaMountain />);
                
            }
            if(d.find((s)=>s.tipo=="presion")!=undefined){
                icons.push(<WiBarometer/>);
            }if(d.find((s)=>s.tipo=="gps")!=undefined){
                icons.push(<TbGps/>);
            }if(d.find((s)=>s.tipo=="acelerometro")!=undefined){
                icons.push(<LuMove3D/>);
            }if(d.find((s)=>s.tipo=="giroscopio")!=undefined){
                icons.push(<LuRotate3D/>);
            }
            if(icons.length==0){
                icons.push(<GiCancel/>)
            }
            setSensoresIcons(icons);
        })
    },[])

    const renderDispositivo1 = ()=>{
        navigate("/dispositivo/"+props.dispositivo.id+"/"+sensoresIcons.length+"/historico")
    }
    const renderDispositivo2 = ()=>{
      navigate("/dispositivo/"+props.dispositivo.id+"/"+sensoresIcons.length+"/mediciones")
  }
    const modificarDispositivo = ()=>{
        cambiarEstadoDispositivo(props.dispositivo).finally(()=>{
            handleClose();
            props.setIsModify(!props.isModify);
            }
        
        );
        
    }

    var estado = props.dispositivo.estado=='encendido'?"Success":"Secondary";
    
  return (
    // <Card
   
    isRender?
    <>
    <Modal show={show} onHide={handleClose} {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
        <Modal.Header closeButton>
          <Modal.Title>Desea cambiar el estado del dispositivo?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Dispositivo: {props.dispositivo.nombre}</p>
            <p>ID: {props.dispositivo.id}</p></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={modificarDispositivo}>
            {props.dispositivo.estado==='apagado' && "Encender"}
            {props.dispositivo.estado==='encendido' && "Apagar"}
          </Button>
          <Button variant="primary" onClick={renderDispositivo1}>
            Historico
          </Button>
          <Button variant="primary" onClick={renderDispositivo2}>
            Mediciones
          </Button>
        </Modal.Footer>
      </Modal>
    <Card
                     bg={estado.toLowerCase()}
                    key={estado}
                    text={estado.toLowerCase() === 'light' ? 'dark' : 'white'}
                    style={{ width: '18rem' }}
                    className="mb-2"
                    onClick={handleShow}
                    >
        <CardHeader>{props.dispositivo.nombre}</CardHeader>
        <CardBody>
            <CardTitle>{props.dispositivo.nombre} </CardTitle>
            <CardText>
                <p>ID: {props.dispositivo.id}</p>
                <p>Estado: {props.dispositivo.estado.toUpperCase()}</p>
                <p>Sensores: {sensoresIcons.length}</p>
                <div className='sensoresIcons'>{sensoresIcons}</div>
            </CardText>
        </CardBody>
    </Card>  
    </>:
    <>
    <Card
                    bg={estado.toLowerCase()}
                    key={estado}
                    text={estado.toLowerCase() === 'light' ? 'dark' : 'white'}
                    style={{ width: '18rem' }}
                    className="mb-2"
                    >
        <CardHeader>{props.dispositivo.nombre}</CardHeader>
        <CardBody>
        <Placeholder as={Card.Title} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as={Card.Text} animation="glow">
            <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
            <Placeholder xs={6} /> <Placeholder xs={8} />
          </Placeholder>
        </CardBody>
    </Card>  
    
    </>
    )
}

export default TarjetaDispositivos
